import { createContext, useState } from "react";

export const PhoneFrameContext = createContext(null);

export default function PhoneFrame({ children, className = "", scroll = true }) {
  const [frameEl, setFrameEl] = useState(null);

  return (
    <div className="w-full h-[100vh] flex justify-center items-center overflow-hidden">
      <div className="w-[250vw] h-[250vh] fixed -top-[100%] -right-[100%] pointer-events-none">
        <div className="border bg"></div>
      </div>
      <div
        ref={setFrameEl}
        className={`w-[480px] h-full max-h-[100vh] relative z-50 shadow-md ${
          scroll ? "overflow-y-auto overflow-x-hidden phone-scroll" : "overflow-hidden"
        } ${className}`}
      >
        <PhoneFrameContext.Provider value={frameEl}>
          {children}
        </PhoneFrameContext.Provider>
      </div>
    </div>
  );
}
